import apiClient from '../apiClient';
import { GET_ACCOMODATION_ITEM_SERVICE_TYPE_LIST_URL } from '../apiUrl';

const getAccomodationItemServiceTypeListApi = () => {
  return apiClient.get(GET_ACCOMODATION_ITEM_SERVICE_TYPE_LIST_URL);
};

export default getAccomodationItemServiceTypeListApi;
